import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root')

// FR-KIO-6 — a stray two-finger gesture must not zoom the kiosk out of shape.
document.addEventListener('gesturestart', (event) => event.preventDefault())
document.addEventListener('contextmenu', (event) => event.preventDefault())

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
